import CircuitBreakerSVG from "../SLD/CircuitBreakerSVG";
import EvSLD from "../SLD/EvSLD";
import PowerMeterSVG from "../SLD/PowerMeterSVG";

const Ev = ({ index, status }) => {
    return (<svg  
        className={`pointer`}
        style={status ? {} : { display: "none", pointerEvents: "none" }}>
        <EvSLD index ={index} />
        <PowerMeterSVG
            id={"_EV"}
            x={-53}
            y={0}
            index={index}
             isEVCb={true}
        />
        <CircuitBreakerSVG
            id={"_EV"}
            x={42}
            y={0}
            index={index}
            cbRequiredSelection={true}
            isEVCb={true}
        />
    </svg>);
};
export default Ev;